/**
 * The transcript-export download (R20/D86, extracted R35 when the session
 * view met the file-size cap) — the session as a printed artifact, serialized
 * by the engine from the record alone; the blob download is app-shell
 * territory, the one place browser APIs belong.
 *
 * @packageDocumentation
 */

import type { GameDescription } from '@orpheus/api-contracts';
import type { PlayHost } from '@orpheus/player-host';

/**
 * Serialize the session and hand the browser a download.
 *
 * @param host - The host holding the session, which serializes the record
 * @param game - The game, for the file name
 * @param seed - The session seed, for the file name
 */
export const downloadTranscriptExport = async (host: PlayHost, game: GameDescription, seed: number | undefined): Promise<void> => {
	const artifact = await host.exportTranscript();
	const blobUrl = URL.createObjectURL(new Blob([artifact], { type: 'text/plain;charset=utf-8' }));
	const anchor = document.createElement('a');
	// D86 addendum (Calder's R20 flag): sanitize the filename DELIBERATELY —
	// dropped punctuation reads as intent, where the browser's underscore
	// substitution for the title's colon read as a typo. Characters illegal on
	// any common filesystem are removed, not replaced.
	const fileTitle = game.title
		.replace(/[":*?<>|/\\]/gu, '')
		.replace(/\s+/gu, ' ')
		.trim();

	anchor.href = blobUrl;
	anchor.download = `${fileTitle} — seed ${String(seed)}.txt`;
	anchor.click();
	URL.revokeObjectURL(blobUrl);
};
